import { atom, selectorFamily } from 'recoil';
import type { ActionableContext, TreeActionableContext } from 'venn-api';
import { getContext } from 'venn-utils';

export const currentContextState = atom<string | undefined>({
  key: 'currentContextState',
  default: undefined,
});

export const defaultContextState = atom<string | undefined>({
  key: 'defaultContextState',
  default: undefined,
});

export const availableContextsState = atom<TreeActionableContext[] | undefined>({
  key: 'availableContextsState',
  default: undefined,
});

export const context = selectorFamily<ActionableContext | undefined, string>({
  key: 'context',
  get:
    (contextId) =>
    ({ get }) => {
      const contexts = get(availableContextsState);
      if (!contexts) {
        return undefined;
      }
      return getContext(contextId, contexts);
    },
});
